import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Week from "./Week/Week.js";
import data from "../../Data/weeks/weeksData.json";

export default function Prevention() {
  // Разворачиваем массив один раз (не трогаем исходный data)
  const reversedData = [...data].reverse();

  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const handlePrev = () => {
    setIndex((prev) => (prev === 0 ? reversedData.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setIndex((prev) => (prev === reversedData.length - 1 ? 0 : prev + 1));
  };

  const handleDetailsClick = () => {
    const currentWeek = reversedData[index];
    navigate("/patients/week", { state: { weekId: currentWeek.id } });
  };

  return (
    <section className="prevention">
      <div className="prevention__block">
        <Week
          Week_text_h2={reversedData[index].title}
          Week_text_p={reversedData[index].text || ""}
        />

        <h4 className="prevention__button">
          <button onClick={handleDetailsClick} className="prevention__link">
            Подробнее
          </button>
        </h4>

        <button className="prevention__left" onClick={handlePrev}></button>
        <button className="prevention__right" onClick={handleNext}></button>

        <div className="prevention__dots">
          {reversedData.map((_, i) => (
            <button
              key={i}
              className={`prevention__dot-${
                i === index ? "active" : "inactive"
              }`}
              onClick={() => setIndex(i)}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}
